"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.myAccount = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.myAccount = (0, basic_1.applyBase)({
    logoutButton: {
        color: 'defaultText',
        fontWeight: 'normal',
        '.icon': {
            ml: 2,
        },
        '&:hover, &:focus': {
            color: 'primary',
            textDecoration: 'none',
        },
    },
    accountLink: Object.assign(Object.assign({ display: 'flex', justifyContent: 'space-between' }, font_faces_1.FONT_SIZE.LINK_LARGE), { textAlign: 'left', width: ['100%', 'auto'], p: [2, 0], borderTop: ['1px solid', 'none'], borderBottom: ['1px solid', 'none'], borderColor: 'borderColor', mb: ['-1px', 0], borderRadius: 0 }),
    successMessage: {
        fontSize: [2, '18px'],
    },
    successMessageBullets: {
        listStyle: 'disc',
        ml: '12px',
        pt: '10px',
        fontSize: [2, '14px'],
    },
});
//# sourceMappingURL=my-account.js.map